//Base logic for Arena and Phoenix

require('es6-promise').polyfill();
require('fetch-ie8');
var hogan = require("hogan.js");
var defaultConfiguration = require('../../gamecfg.json');
var pixi = require('pixi.js');
var Factive = require('exports?Factive!GameRenderer');
var StyleSheet = require("styles");
var FontFaceObserver = require("fontfaceobserver");
var LocalStorage = require("store");
var RequireScripts = require.context('scripts', true, /[A-z]+\/[A-z]+$/);
var RequireTemplates = require.context('templates', true, /[A-z]+\/[A-z]+$/);
var pixiDisplay = require('pixi-display');
var watchObject = require('watch-object');
window.THREE = require('../../node_modules/three/build/three.min');
window.CANNON = require('../../node_modules/cannon/build/cannon.min');
require('../../node_modules/cannon/tools/threejs/CannonDebugRenderer.js');

var MobileDetect = require('mobile-detect');

var Howl = null;
var Howl2 = null;

if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)))
{
    Howl = require('../libs/howler1.min');
}
else
{
    Howl2 = require('../libs/howler2');


    HowlerSound = function(o) {

        // var md = new MobileDetect(window.navigator.userAgent);
        // if(!!md.phone() == false
        //     && !!md.tablet() == false
        //     && !!md.mobile() == false)
        // {
        //     this._webAudio = false; // pc
        // }
        // else {
        //     this._webAudio = true; // mobile
        // }

        this._webAudio = true;

        Howl2.Howl.call(this, o);
        this._paused = false;
        this._stopped = true;
        this._canBeDestroyed = false;
        this._rate = o.rate || 1; //Read-only

        //Add custom events listener to keep
        //track of the sound status.
        var that = this;
        this.on('end', function() {
            if (!that.loop()) {
                that._canBeDestroyed = true;
                that._paused = false;
                that._stopped = true;
            }
        });
        this.on('play', function() {
            that._paused = false;
            that._stopped = false;
        });
        this.on('pause', function() {
            that._paused = true;
            that._stopped = false;
        });
    };
    HowlerSound.prototype = Object.create(Howl2.Howl.prototype);

    HowlerSound.prototype.paused = function() {
        return this._paused;
    };
    HowlerSound.prototype.stopped = function() {
        return this._stopped;
    };
    HowlerSound.prototype.stop = function() {
        this._paused = false;
        this._stopped = true;
        return Howl2.Howl.prototype.stop.call(this);
    };
    HowlerSound.prototype.canBeDestroyed = function() {
        return this._canBeDestroyed;
    };
    HowlerSound.prototype.rate = function() {
        return this._rate;
    };
}

require("../libs/GoogleAnalytics.js");

ARK_game_arena_connector  = require('exports?ARK_game_arena_connector!../libs/arena-api-1.2.3');

var introscreen1xSke = require('../resources/assets/images/1x/introscreen_ske.json');
var introscreen1xTex = require('../resources/assets/images/1x/introscreen_tex.json');
var introscreen2xSke = require('../resources/assets/images/2x/introscreen_ske.json');
var introscreen2xTex = require('../resources/assets/images/2x/introscreen_tex.json');
var SoundsConfigJSON = require('../resources/assets/sounds/config.json');
var supportLanguages =[
    { "value": "en", "localization":"en-US", "name": "English" }
    ,{ "value": "de", "localization":"de-DE", "name": "Deutsch" }
    ,{ "value": "es", "localization":"es-ES", "name": "Español" }
    ,{ "value": "fr", "localization":"fr-FR", "name": "Français" }
    ,{ "value": "it", "localization":"it-IT", "name": "Italiano" }
];
var gup = function( name, url ) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
};
var FiveRollGame = function (elementId,devicePixelRatio)
{
    this.resourcesRoot = defaultConfiguration.settings.resourcesRoot || "";
    this.configuration = defaultConfiguration;

    this.container = new Factive.Core.DependenciesContainer();
    this.container.singleton("Configuration", this.configuration);

    var localization = "en-US";
    for (var i=0;i<supportLanguages.length;i++){
        if(supportLanguages[i].value == (gup('ark-lang') || this.configuration.language)){
            localization = supportLanguages[i].localization;
            break;
        }
    }

    this.container.singleton("Localization", localization);
    this.container.registerScripts(RequireScripts);
    this.container.registerTemplates(RequireTemplates);
    this.container.singleton("FontFaceObserver", {
        create: function (name)
        {
            return new FontFaceObserver(name);
        }
    });
    this.container.singleton("LocalStorage", LocalStorage);
    this.container.singleton("DevicePixelRatio", devicePixelRatio || 1);
    this.container.singleton("PIXI", pixi);
    this.container.singleton("StyleSheet", StyleSheet);
    this.container.singleton("ModuleIndex", this.getGameIndex());
    this.container.singleton("ResourcesRoot", this.resourcesRoot);
    this.container.singleton("Version", defaultConfiguration.version);
    this.container.singleton("Window", window);
    this.container.singleton("hogan", hogan);
    this.container.singleton("WatchObject", watchObject);
    this.container.singleton("soundConfig", SoundsConfigJSON);
    this.container.singleton("MobileDetect", new MobileDetect(window.navigator.userAgent));
    console.log("Version:" + this.container.get("Version"));

    if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)))
    {
        this.container.singleton("HowlConstructor", Howl.Howl);
    }
    else
    {
        this.container.singleton("HowlerSound", HowlerSound);
        this.container.singleton("Howler", Howl2.Howler);
    }

    this.container.singleton("Introscreen1xSke", introscreen1xSke);
    this.container.singleton("Introscreen1xTex", introscreen1xTex);
    this.container.singleton("Introscreen2xSke", introscreen2xSke);
    this.container.singleton("Introscreen2xTex", introscreen2xTex);

    pixi.utils.skipHello();

    var template = this.container.get("main/index");
    template = template.split("%RESOURCEPATH%").join(this.resourcesRoot);
    var view = hogan.compile(template);

    var viewport = document.getElementById(elementId || 'gamePlace');

    var style = StyleSheet.split("%RESOURCEPATH%").join(this.resourcesRoot);

    viewport.insertAdjacentHTML("afterbegin", view.render({
        model: this.entity,
        style: {
            content: style
        }
    }));
    this.createCanvas(viewport.firstChild);
};

FiveRollGame.prototype.constructor = FiveRollGame;
FiveRollGame.moduleName = "FiveRollGame";
FiveRollGame.moduleIndex = 0;
FiveRollGame.prototype.getGameIndex = function ()
{
    return "FiveRollGame_" + FiveRollGame.moduleIndex++;
};

FiveRollGame.prototype.createCanvas = function (element)
{
    var gameMain = this.container.get("GameMain", {
        element: element
    });

    gameMain.create().then(function (game){

        },
    function (error){

    });
};

module.exports = FiveRollGame;


//////////////////
// WEBPACK FOOTER
// ./src/scripts/BaseFiveRollGame.js
// module id = 7
// module chunks = 0